import blog from './blog';
import bookingCatalog from './bookingCatalog';
import ecommerceCatalog from './ecommerceCatalog';

export default {
  blog,
  ecommerceCatalog,
  bookingCatalog,
};
